import { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';

import { fetchFilingsSources } from '../../../../../actions/filings.actions';
import { filterBySource } from '../../../../../actions/filingsFilters.actions';
import DropdownRow from './DropdownRow';
import withComponentName from '../../../../../decorators/withComponentName';

import StorageSvc from '../../../../../services/StorageSvc';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

class SourceFilingsDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      dropdown: {
        isSelectAll: false,
        selected: [],
        options: [],
      },
    };
    autoBind(this);
  }

  componentDidMount() {
    const { fetchFilingsSources: propsFetchFilingsSources } = this.props;

    const presistedState = StorageSvc.getItem('FilingsSourceFilter');
    if (presistedState !== null) {
      const rehydrate = JSON.parse(presistedState);
      this.setState({ dropdown: rehydrate.dropdown });
    } else {
      propsFetchFilingsSources({ active: true })
        .then((data) => {
          const { filing_source_ids: selecetdIds, filing_sources_all: isAllSelected } = this.props;
          const selected = [];
          const options = [];
          for (let i = 0; i < data.length; i += 1) {
            const currentData = data[i];
            const isSelected = selecetdIds.includes(currentData.sources_id);
            if (isSelected || isAllSelected) {
              selected.push({
                ...currentData,
                select: true,
              });
              options.push({
                ...currentData,
                select: true,
              });
            } else {
              options.push(currentData);
            }
          }
          this.setState({
            dropdown: {
              selected,
              options,
              isSelectAll: selecetdIds.length === data.length || isAllSelected,
            },
          });
        });
    }
  }

  componentDidUpdate(prevProps) {
    const { isReset, isSourceReset } = this.props;
    if ((isReset && isReset !== prevProps.isReset)
      || (isSourceReset && isSourceReset !== prevProps.isSourceReset)) {
      const { dropdown } = this.state;
      const { options } = dropdown;
      const newOptions = options.map((option) => ({ ...option, select: true }));
      this.setState({
        dropdown: {
          isSelectAll: true,
          selected: newOptions,
          options: newOptions,
        },
      }, () => {
        const { token } = this.props;
        const { dropdown: stateDropdown } = this.state;
        if (!token) {
          StorageSvc.setItem(
            'FilingsSourceFilter',
            JSON.stringify({ dropdown: stateDropdown }),
          );
        }
      });
    }
  }

  handleToggle(status, event, source) {
    // workaround for IE11 to prevent double toggle when user clicks on
    // dropdown button to close dropdown
    if (
      status === false
      && source.source === 'select'
    ) {
      return;
    }

    this.setState({
      isMenuOpen: status,
    });
  }

  handleSelectAllClick() {
    const { dropdown } = this.state;
    const { piwikEnabled } = this.props;
    const { isSelectAll, options } = dropdown;
    if (isSelectAll) {
      this.setState({
        dropdown: {
          isSelectAll: false,
          selected: [],
          options: options.map(({ select, ...restData }) => restData),
        },
      }, () => {
        this.saveState();
      });
    } else {
      const newOptions = options.map((option) => ({ ...option, select: true }));
      this.setState({
        dropdown: {
          isSelectAll: true,
          selected: newOptions,
          options: newOptions,
        },
      }, () => {
        this.saveState();
      });
    }
    if (piwikEnabled) {
      _paq.push(['trackEvent', 'Filings', `sources selected/unselected all ${options}`]);
    }
  }

  handleRowSelect(value, isSelected) {
    const { dropdown } = this.state;
    const { piwikEnabled } = this.props;
    const { selected, options } = dropdown;
    const optionIndex = options.findIndex((f) => f.sources_id === value.sources_id);
    if (isSelected) {
      const foundIndex = selected.findIndex((f) => f.sources_id === value.sources_id);
      if (piwikEnabled) {
        _paq.push(['trackEvent', 'Filings source filters', `Unselected value: ${options[optionIndex]}`]);
      }
      const newSelectedValues = [
        ...selected.slice(0, foundIndex),
        ...selected.slice(foundIndex + 1),
      ];
      options[optionIndex].select = false;
      this.setState({
        dropdown: {
          ...dropdown,
          isSelectAll: newSelectedValues.length === options.length,
          selected: newSelectedValues,
          options,
        },
      }, () => {
        this.saveState();
      });
    } else {
      selected.push(value);
      options[optionIndex].select = true;
      if (piwikEnabled) {
        _paq.push(['trackEvent', 'Filings source filters', `Selected value: ${options[optionIndex]}`]);
      }
      this.setState({
        dropdown: {
          ...dropdown,
          isSelectAll: selected.length === options.length,
          selected,
          options,
        },
      }, () => {
        this.saveState();
      });
    }
  }

  handleMenuCloseEvent() {
    this.setState({
      isMenuOpen: false,
    });
  }

  saveState() {
    const { token, filterBySource: propsFilterBySource } = this.props;
    const { dropdown } = this.state;
    const { selected, isSelectAll } = dropdown;

    if (!token) {
      StorageSvc.setItem(
        'FilingsSourceFilter',
        JSON.stringify({ dropdown }),
      );
    }
    const Ids = selected.map((e) => e.sources_id);
    propsFilterBySource({ filing_source_ids: Ids, filing_sources_all: isSelectAll }, token);
  }

  render() {
    const { isMenuOpen, dropdown } = this.state;
    const { isSelectAll, selected = [], options = [] } = dropdown;
    const dropdownTitle = !isSelectAll && selected.length
      ? selected.map((e) => e.full_name).join(', ')
      : 'All Sources';

    return (
      <div
        id="filings_sources_dropdown"
        className={cx('filings-filter-btn', 'sources_dropdown')}
      >
        <Dropdown onToggle={this.handleToggle} show={isMenuOpen}>
          <Dropdown.Toggle>
            <div className={Styles.sources_header}>
              <div className={Styles.header_holder}>
                <div className={Styles.main_header}>{dropdownTitle}</div>
                <div className={Styles.sub_header}>Source</div>
              </div>
              <div className={Styles.header_icon}>
                <FontAwesomeIcon icon={isMenuOpen ? faChevronUp : faChevronDown} />
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu flip={false}>
            <div className="dropdown-items-wrapper">
              <div className="dropdown_title">
                Source:
              </div>
              <FontAwesomeIcon
                className="dropdown_close"
                icon={faXmark}
                onClick={this.handleMenuCloseEvent}
              />
              <Dropdown.Item eventKey="selectAll" active={isSelectAll} onSelect={this.handleSelectAllClick}>
                <FontAwesomeIcon icon={isSelectAll ? faCheckSquare : faSquare} />
                <span className="dropdown__checkbox_title select_all">Select / Unselect All</span>
              </Dropdown.Item>
              {
                options.map(({
                  sources_id: id,
                  name,
                  select,
                  full_name: fullName,
                }) => (
                  <DropdownRow
                    key={id}
                    isSelectAll={isSelectAll}
                    id={id}
                    name={name}
                    fullName={fullName}
                    select={select}
                    handleRowSelect={this.handleRowSelect}
                  />
                ))
              }
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

const mapToStateProps = ({ filings, watchlistReducer, storyFilters }) => ({
  sources: filings.sources,
  token: watchlistReducer.userToken,
  filing_source_ids: storyFilters.filing_source_ids || [],
  filing_sources_all: storyFilters.filing_sources_all,
});

const mapToDispatchProps = {
  fetchFilingsSources,
  filterBySource,
};

export default withComponentName(
  connect(mapToStateProps, mapToDispatchProps)(SourceFilingsDropdown),
);
